// extracted by mini-css-extract-plugin
module.exports = {"button":"motion-tooltip_button__kjFeW"};